import { Grid } from "@mui/material";
import { useEffect, useRef } from "react";
import Subscription from "../../actions/Subscription";
import Controls from "../controls/Controls";
import { Form, useForm } from "../customHelpers/useForm";
import {
  Autocomplete,
  Box,
  FormHelperText,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import CheckIcon from "@mui/icons-material/Check";
import Organization from "../../actions/organization";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import ConfirmDialog from "../customHelpers/ConfirmDialog";
const initialFValues = {
  value: "",
  editing: false,
};
const AddOrganizationSubscription = ({
  NotifyMessage,
  setOpenPopup,
  recordForEdit,
  edite,
  getSubscription,
  id,
}) => {
  const {
    viewOrgSubscriptions,
    addOrganizationSubscription,
    updateOrganizationSubscription,
  } = Subscription();
  const validate = (fieldValues = values) => {
    const temp = { ...errors };
    if ("value" in fieldValues)
      temp.value =
        fieldValues.value.length !== 0 ? "" : "This field is required.";

    setErrors({
      ...temp,
    });
    if (fieldValues == values) return Object.values(temp).every((x) => x == "");
  };
  const { viewOrganizations } = Organization();
  const [organization, setOrganization] = useState([]);
  const [orgSubscriptions, setOrgSubscriptions] = useState([]);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const [roleError, setRoleError] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  useEffect(() => {
    if (recordForEdit != null) {
      setValues({
        ...recordForEdit,
      });
      setEndDate(
        recordForEdit.expiredDate ? dayjs(recordForEdit.expiredDate) : null
      );
      setStartDate(
        recordForEdit.startDate ? dayjs(recordForEdit.startDate) : null
      );
    }
  }, [recordForEdit]);
  const { values, errors, setValues, handleInputChange, setErrors, resetForm } =
    useForm(initialFValues, true, validate);
  const firstFieldRef = useRef(null);
  useEffect(() => {
    if (firstFieldRef.current) {
      firstFieldRef.current.focus();
    }
  }, []);
  const handleSubmit = () => {
    setValues({ ...values, submitting: true });
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    if (edite === false) {
      addOrganizationSubscription({
        organization_Id: selectedOrganization.id,
        Subscription_ID: id,
        startDate: startDate,
        expiredDate: endDate,
      }).then((data) => {
        if (data.err) {
          setValues({ ...values, submitting: false });
          NotifyMessage({
            message: data.err,
            type: "error",
          });
        } else if (data.subscription) {
          NotifyMessage({
            message: "Organization Subscription successfully created",
            type: "success",
          });
          setOpenPopup(false);
          getSubscription();
          resetForm();
        }
      });
    } else {
      updateOrganizationSubscription(
        {
          startDate: startDate,
          expiredDate: endDate,
        },
        id
      ).then((data) => {
        if (data.err) {
          setValues({ ...values, submitting: false });
          NotifyMessage({
            message: data.err,
            type: "error",
          });
        } else if (data.subscription) {
          NotifyMessage({
            message: "Organization Subscription successfully updated",
            type: "success",
          });
          getSubscription();
          setOpenPopup(false);
          resetForm();
        }
      });
    }
  };
  useEffect(() => {
    getAllOrganizations();
  }, []);

  const getAllOrganizations = () => {
    setValues({ ...values, loading: true });
    viewOrganizations().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
        setValues({
          ...values,
          loading: false,
        });
      } else if (data.organizations) {
        setValues({
          ...values,
          loading: false,
        });
        setOrganization(data.organizations);
      }
    });
    viewOrgSubscriptions().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.subscriptionService) {
        setOrgSubscriptions(data.subscriptionService);
      }
    });
  };
  const handleChange = (event, newValue) => {
    if (newValue) {
      setSelectedOrganization(newValue);
    }
  };
  const handleStartDateChange = (newValue) => {
    setStartDate(newValue);
  };
  const handleEndDateChange = (newValue) => {
    setEndDate(newValue);
  };
  const checkSubscriptionExist = (e) => {
    e.preventDefault();
    if (recordForEdit === null && selectedOrganization === null) {
      setRoleError(true);
      setValues({ ...values, submitting: false });
      return null;
    }
    if (startDate && endDate && startDate.isAfter(endDate)) {
      NotifyMessage({
        message: "Start date cannot be after expired date.",
        type: "error",
      });
      return;
    }
    if (startDate === null || endDate === null) {
      NotifyMessage({
        message: "Start and Expired date are required.",
        type: "error",
      });
      return;
    }
    if (recordForEdit !== null) {
      handleSubmit();
    } else {
      const existingItem = orgSubscriptions.find(
        (item) => item.organization_Id === selectedOrganization.id
      );

      if (existingItem) {
        setConfirmDialog({
          isOpen: true,
          title: (
            <>
              This organization is already linked to{" "}
              <span style={{ color: "rgba(244,151,3,.8)", fontWeight: "bold" }}>
                {existingItem.subscription.name}
              </span>{" "}
              subscription.
            </>
          ),
          subTitle:
            "Do you want to unlink it and continue with the new subscription?",
          onConfirm: () => {
            handleSubmit();
          },
        });
      } else {
        handleSubmit();
      }
    }
  };
  return (
    <Form onSubmit={checkSubscriptionExist}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Start Date"
              value={startDate}
              onChange={handleStartDateChange}
              slotProps={{
                field: { clearable: true },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} md={6}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Expired Date"
              value={endDate}
              onChange={handleEndDateChange}
              slotProps={{
                field: { clearable: true },
              }}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item xs={12} md={6}>
          {recordForEdit === null && (
            <>
              <Autocomplete
                options={organization}
                getOptionLabel={(option) => option.organization_name}
                onChange={handleChange}
                value={selectedOrganization}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Select Organization"
                  />
                )}
                renderOption={(props, option, { selected }) => (
                  <MenuItem
                    {...props}
                    key={option.id}
                    value={option.id}
                    sx={{ justifyContent: "space-between" }}
                  >
                    {option.organization_name}
                    {selected ? <CheckIcon color="info" /> : null}
                  </MenuItem>
                )}
              />
              {roleError && (
                <FormHelperText error>
                  Please select one Organization
                </FormHelperText>
              )}
            </>
          )}
        </Grid>
        {selectedOrganization && (
          <Grid item xs={12} md={6}>
            <Box mt={2}>
              <Typography variant="body1">
                <strong>Phone Number:</strong> {selectedOrganization.phoneNo}
              </Typography>
              <Typography variant="body1">
                <strong>Email:</strong> {selectedOrganization.email}
              </Typography>
            </Box>
          </Grid>
        )}
        {!selectedOrganization && <Grid item xs={12} md={6} />}

        <Grid item xs={12}>
          <div>
            <Controls.Button
              disabled={values.submitting ? true : false}
              text={
                edite === true
                  ? values.submitting
                    ? "Editing..."
                    : "Done"
                  : values.submitting
                  ? "Adding..."
                  : "Add"
              }
         
              type="submit"
            />
            <Controls.Button
              text={"Cancel"}
              color="default"
              onClick={() => {
                setOpenPopup(false);
              }}
            />
          </div>
          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
        </Grid>
      </Grid>
    </Form>
  );
};

export default AddOrganizationSubscription;
